import { IViewerFloor } from "../../../interfaces/IViewerFloor";
import { FloorSelectionExtensionCallbacks } from "./floorSelectionExtensionCallbacks";
import { FloorSelectionExtensionOptions } from "./floorSelectionExtensionOptions";
import { FloorSelectorToolbar } from "./floorSelectorToolbar";

export class FloorSelectorSimpleToolbar extends FloorSelectorToolbar {
	public constructor(public options: FloorSelectionExtensionOptions, public floorToolBar: Autodesk.Viewing.UI.ToolBar) {
		super(options, floorToolBar);
	}

	public async builtToolbarAsync(activeFloorLevel: number): Promise<void> {
		if (this.subToolbar == null) {
			const options = this.options;
			const buttonCallbacks = {};

			this.subToolbar = new Autodesk.Viewing.UI.ControlGroup(`${options.autodeskContainerId}-floor-subtoolbar`);

			const viewFloors = await Promise.all<IViewerFloor>(options.viewerFloors.listAsync);
			// floors are sorted from top to bottom, because that's the way they are to be added to the toolbar
			viewFloors.sort((a, b) => b.floor.level - a.floor.level);

			viewFloors.forEach((vf) => {
				const button = this.createToolbarButton(this.subToolbar, vf, buttonCallbacks);

				if (vf.floor.level === activeFloorLevel) {
					this.activateFloor(button);
				}
			});

			const callbacks: FloorSelectionExtensionCallbacks = {
				activateFloor: (level: number): void => {
					buttonCallbacks[level]();
				},
			};

			options.callbackContext = callbacks;

			this.floorToolBar.addControl(this.subToolbar);
		}
	}
}
